import { registerI18nLoader } from "./asset-registries/i18n.js";
import { registerLocaleDataLoader } from "./asset-registries/LocaleData.js";
import { registerThemePropertiesLoader, registerCustomThemePropertiesLoader } from "./asset-registries/Themes.js";
import { registerIconLoader } from "./asset-registries/Icons.js";

export {
	registerI18nLoader,
	registerLocaleDataLoader,
	registerThemePropertiesLoader,
	registerCustomThemePropertiesLoader,
	registerIconLoader,
};
